import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';

export const CELL_SIZE = 32;

export const WeekHeaderGrid = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(7, 1fr)',
  gap: '5px',
  justifyItems: 'center',
  alignItems: 'center',
  marginBottom: theme.spacing(1),
}));

export const DayGrid = styled(Box)({
  display: 'grid',
  gridTemplateColumns: 'repeat(7, 1fr)',
  gridAutoRows: 'auto',
  gap: '8px 0',
  justifyItems: 'center',
  alignItems: 'center',
});

export const CellOuter = styled(Box, {
  shouldForwardProp: prop => prop !== 'isClickable',
})(({ isClickable }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  paddingTop: '2px',
  paddingBottom: '2px',
  position: 'relative',
  cursor: isClickable ? 'pointer' : 'default',
}));

const statusStyleMap = {
  available: theme => ({
    border: '1.334px solid',
    borderColor: theme.palette.darkSand.white40,
    backgroundColor: theme.palette.common.white,
    color: theme.palette.text.primary,
    cursor: 'pointer',
    '&:hover': { borderColor: theme.palette.secondary.main },
  }),
  onRequest: theme => ({
    border: '1.334px solid',
    borderColor: theme.palette.darkSand.white40,
    backgroundColor: theme.palette.common.white,
    color: theme.palette.text.primary,
    cursor: 'pointer',
    '&:hover': { borderColor: theme.palette.secondary.main },
  }),
  unavailable: theme => ({
    backgroundColor: theme.palette.action.disabledBackground,
    color: theme.palette.text.secondary,
  }),
  loading: theme => ({
    backgroundColor: theme.palette.action.disabledBackground,
    color: theme.palette.text.secondary,
  }),
  past: theme => ({
    backgroundColor: theme.palette.action.disabledBackground,
    color: theme.palette.text.secondary,
  }),
  selected: theme => ({
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.vividOrange.black80,
    cursor: 'pointer',
    border: '1.334px solid',
    borderColor: theme.palette.secondary.main,
    fontWeight: 600,
  }),
  selectedTween: theme => ({
    backgroundColor: theme.palette.vividOrange.white40,
    color: theme.palette.vividOrange.black80,
    cursor: 'pointer',
    border: '1.334px solid',
    borderColor: theme.palette.vividOrange.white40,
  }),
  hoverPreview: theme => ({
    backgroundColor: theme.palette.vividOrange.white40,
    color: theme.palette.vividOrange.black80,
    cursor: 'pointer',
    border: '1.334px solid',
    borderColor: theme.palette.vividOrange.white40,
  }),
  outOfMonth: () => ({
    backgroundColor: 'rgba(0,0,0,0.06)',
    color: 'rgba(0,0,0,0.35)',
  }),
};

export const CalendarCell = styled(Box, {
  shouldForwardProp: prop => prop !== 'status',
})(({ theme, status }) => ({
  aspectRatio: '1',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '0.875rem',
  lineHeight: 1,
  borderRadius: '50%',
  userSelect: 'none',
  width: '100%',
  maxWidth: CELL_SIZE,
  zIndex: 1,
  ...(status && statusStyleMap[status] ? statusStyleMap[status](theme) : {}),
}));

export const EnquiryButton = styled(Button)(({ theme }) => ({
  textTransform: 'uppercase',
  fontWeight: 600,
  fontSize: '0.75rem',
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  backgroundColor: theme.palette.stoneGrey.base,
  color: theme.palette.text.primary,
  border: '1px solid',
  borderColor: theme.palette.darkBrown.white80,
  '&:hover': { backgroundColor: theme.palette.stoneGrey.black20 },
}));
